import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import useWishlist from '@/shared/product/wishlist/useWishlist';
import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import { Component, computed, watch } from 'vue';
import authStore from '@/shared/auth/auth.store';
import WishlistLogin from '@/shared/product/wishlist/ui/WishlistLogin.vue';
import WishlistLists from '@/shared/product/wishlist/ui/WishlistLists.vue';
import { router } from '@/core/router';
import { useWishlistApi } from '@/shared/product/wishlist/useWishlistApi';


export default /*#__PURE__*/_defineComponent({
  __name: 'WishlistOverlay',
  setup(__props) {

const { active, clearActive, setLists } = useWishlist();
const { get } = useWishlistApi();

// MPE: quickfix for initialization, this should only be based on authStore.isSignedIn, but some bug from the old part of the site retains userinfo in the access_token on session timeout
const shouldInitWishlist = computed(() => authStore.isSignedInAsB2C || authStore.isSignedInAsPartner);

const componentByAuth = computed<Component>(() => {
    return shouldInitWishlist.value ? WishlistLists : WishlistLogin;
});

const init = async() => {
    if (shouldInitWishlist.value) {
        const result = await get();
        setLists(result);
    }
};
init();

watch(router.currentRoute, clearActive);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseDialog, {
    "is-open": _unref(active),
    class: "fixed inset-0 pt-x4 pb-x3 mx-auto z-1 bg-white sm:max-w-500 sm:relative sm:inset-auto sm:h-auto sm:w-screen-80 xl:max-w-600",
    onClose: _unref(clearActive)
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(componentByAuth))))
    ]),
    _: 1
  }, 8, ["is-open", "onClose"]))
}
}

})